query WfaSessionSeverities($runId: ConditionID!) {
	wfa_session_type_runs(run_id_eq: $runId, group: severity_name) {
		severity_id_any
		severity_name_any
		total_issues_sum
	}
}
